import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	logo: {
		data: [],
		isLoaded: false,
		error: false
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** FETCH SETTINGS'S LOGO FILES ******************
			case types.FETCH_SETTINGS_LOGO_FILES_LOADING:
				draft.logo.data = [];
				draft.logo.isLoaded = false;
				draft.logo.error = false;
				return;

			case types.FETCH_SETTINGS_LOGO_FILES_SUCCESS:
				draft.logo.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.logo.isLoaded = true;
				return;

			case types.FETCH_SETTINGS_LOGO_FILES_ERROR:
				draft.logo.isLoaded = true;
				draft.logo.error = true;
				return;

			default:
				return state;
		}
	});
